import { useTheme } from '@material-ui/core';
import { useMemo } from 'react';
import { ColorX } from './ColorX';
import { mapColorXToThemeColor } from './mapColorXToThemeColor';

export const useThemeColor = (color: ColorX) => {
	const theme = useTheme();
	return useMemo(() => mapColorXToThemeColor(color, theme), [color, theme]);
};
